import { Label2, Tag } from "@bounce/design-system"
import { useFormatDecimals, useTranslation } from "@bounce/i18n"
import { useStoreReviewCount } from "@bounce/store"

import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import StarIcon from "@bounce/assets/icons/Star-filled.svg"

type StoreRatingSecondaryProps = {
  store: Pick<NearbyStorageSpot, "rating" | "reviewCount">
  isReviewCountVisible?: boolean
}

export const StoreRatingSecondary = ({ store, isReviewCountVisible = true }: StoreRatingSecondaryProps) => {
  const { t } = useTranslation()
  const reviewCount = useStoreReviewCount({ store })
  const formatDecimals = useFormatDecimals({ minDecimalPlaces: 1, maxDecimalPlaces: 2 })

  if (!store.rating) {
    return <Tag bgColor="lilac" className="tag" size="large" text={t("cmp.storeRatingSecondary.new", "NEW")} />
  }

  return (
    <div className="flex items-center">
      <StarIcon className="mr-0.5 size-4 text-orange-700" />
      <Label2 className="mr-0.5 !leading-none text-primary-900">{formatDecimals(store.rating)}</Label2>
      {isReviewCountVisible && <Label2 className="!leading-none text-primary-900">({reviewCount})</Label2>}
    </div>
  )
}
